'use client';

import { NavMain } from '@components/nav-main';
import { NavSecondary } from '@components/nav-secondary';
import { SidebarContent } from '@components/ui/sidebar';
import { getRouteItems, ROUTE } from '@utils/route-utils';
import { useTranslations } from 'next-intl';

type AppSidebarContentProps = {
  organization_id: string;
};

export default function AppSidebarContent({
  organization_id
}: AppSidebarContentProps) {
  const t = useTranslations();
  const routeItems = getRouteItems(organization_id, t);

  return (
    <SidebarContent>
      <NavMain organization_id={organization_id} />
      <NavSecondary item={routeItems[ROUTE.LIBRARY]} />
      <NavSecondary item={routeItems[ROUTE.TEAM]} />
      <NavSecondary item={routeItems[ROUTE.UTILITIES]} className="mt-auto" />
    </SidebarContent>
  );
}
